import { render, staticRenderFns } from "./AddReference.vue?vue&type=template&id=c3f74114&"
import script from "./AddReference.vue?vue&type=script&lang=js&"
export * from "./AddReference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports